
export default {
    getAvailableTestClinic(model) {
        return window.restApi.get('v2/test/clinic/available/list', {params: model});
    },
    getAvailableTestPCR(model) {
        return window.restApi.get('v2/test/pcr/available/list', {params: model});
    },
    saveOrderClinic(model, config) {
        if (model.id) {
            return window.restApi.post('v2/queue/clinic/update', model, config);
        } else {
            return window.restApi.post('v2/queue/clinic/save', model, config);
        }
    },
    saveOrderPCR(model, config) {
        if (model.id) {
            return window.restApi.post('v2/queue/pcr/update', model, config);
        } else {
            return window.restApi.post('v2/queue/pcr/save', model, config);
        }
    },
    saveQueueClinic(model, config) {
        return window.restApi.post('v2/queue/clinic/save', model, config);
    },
    saveQueuePcr(model, config) {
        return window.restApi.post('v2/queue/pcr/save', model, config);
    },
    updateQueue(model, config) {
        return window.restApi.post('v2/queue/update', model, config);
    },
    deleteQueue(model, config) {
        return window.restApi.post('v2/queue/delete', model, config);
    },
    getListSpecimentType(model) {
        return window.restApi.get('v2/test/specimenttype/list', {params: model});
    },
    getListSpecimentReject(model) {
        return window.restApi.get('v2/test/specimentreject/list', {params: model});
    },
}
